<div class="modal-header">
  <h4 class="modal-title">{{ 'resend.title' | translate }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" id="resendBody">
  <div [formGroup]="resendForm" *ngIf="showResendForm">
    <div class="row">
      <div class="col-sm-12">
        <span class="font-weight-bold">{{ 'resend.email' | translate }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <tag-input
          [theme]="'bootstrap'"
          formControlName="emailTo"
          modelAsStrings="true"
          [validators]="validators"
          addOnBlur="true"
          maxItems="3"
          placeholder="{{ 'resend.placeholder' | translate }}"
          [errorMessages]="errorMessages"
          (keydown)="isEditEmail = true"
          (onBlur)="isEditEmail = false"
        >
        </tag-input>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-black-50">
        <span
          ><small>{{ 'resend.tooltip' | translate }}</small></span
        >
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-12">
        <span class="font-weight-bold">{{ 'resend.smsTo' | translate }}</span>
      </div>
    </div>
    <div class="row form-height">
      <div class="col-5 form-pt" *ngIf="!isEditMobile">{{ mobileNumber }}</div>
      <div class="col-5" *ngIf="isEditMobile">
        <input
          formControlName="sendSmsTo"
          class="form-control"
          [ngClass]="{ invalid: sendSmsTo.invalid }"
          class="form-control"
          maxlength="10"
          [placeholder]="'resend.smsPlaceholder' | translate"
          appNumbersOnly
        />
      </div>
      <div class="col-1">
        <button class="btn" (click)="editMobile()" [title]="'resend.mobileBtn' | translate">
          <span *ngIf="!isEditMobile"><i class="fas fa-fw fa-edit"></i></span>
          <span *ngIf="isEditMobile"><i class="fas fa-fw fa-check"></i></span>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-danger" *ngIf="isResendError">
        <span class="error">{{ 'resend.fail' | translate }}</span>
      </div>
    </div>
  </div>
  <div #successPage *ngIf="!showResendForm">
    <div class="row">
      <div class="col-sm-12 text-center">
        <span class="font-weight-bold">{{ 'resend.success' | translate }}</span>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-sm-12 text-center">
      <ng-container *ngIf="showResendForm">
        <button type="button" class="col-sm-3 btn btn-danger" (click)="closeModal()">
          {{ 'resend.cancel' | translate }}
        </button>
        <button type="button" class="offset-sm-2 col-sm-3 btn btn-primary" [disabled]="isDisableOkButton()" (click)="resend()">
          {{ 'resend.submit' | translate }}
        </button>
      </ng-container>
      <ng-container *ngIf="!showResendForm">
        <button type="button" class="col-sm-4 btn btn-primary" (click)="closeModal()">
          {{ 'resend.submit' | translate }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
<ngx-loading [show]="loading"></ngx-loading>
